import { render, staticRenderFns } from "./CadastroPacientes.vue?vue&type=template&id=26907877&"
import script from "./CadastroPacientes.vue?vue&type=script&lang=js&"
export * from "./CadastroPacientes.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPacientes.vue?vue&type=style&index=0&id=26907877&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports